/**
 * Immich 写真グリッド (サムネイル + ライトボックス)
 *
 * サムネイルタップでライトボックスを開く。
 * `PhotoGroupCard` と `OverlandVisitCard` で共通利用する。
 */

import { Play } from 'lucide-react'
import { useState } from 'react'

import type { ImmichAsset } from '@/api/services/immich'
import { cn } from '@/lib/utils'

import { ImmichThumbnail } from './immich-thumbnail'
import { PhotoLightbox } from './photo-lightbox'

type Props = {
  assets: ImmichAsset[]
  className?: string
}

export const PhotoGrid = ({ assets, className }: Props) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  if (assets.length === 0) return null

  return (
    <>
      <div className={cn('grid grid-cols-4 gap-1 sm:grid-cols-6', className)}>
        {assets.map((asset, i) => (
          <button
            key={asset.id}
            type="button"
            className="relative aspect-square w-full overflow-hidden rounded p-0"
            onClick={(e) => {
              e.stopPropagation()
              setOpenIndex(i)
            }}
          >
            <ImmichThumbnail
              assetId={asset.id}
              alt={asset.originalFileName || asset.id}
              size="thumbnail"
              className="h-full w-full"
            />
            {asset.type === 'VIDEO' && (
              <span
                className="pointer-events-none absolute right-1 bottom-1 flex items-center justify-center rounded-full bg-black/60 p-1 text-white"
                aria-label="動画"
              >
                <Play className="size-3 fill-current" />
              </span>
            )}
          </button>
        ))}
      </div>

      <PhotoLightbox
        assets={assets}
        index={openIndex ?? 0}
        onIndexChange={setOpenIndex}
        open={openIndex !== null}
        onOpenChange={(open) => {
          if (!open) setOpenIndex(null)
        }}
      />
    </>
  )
}
